import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col, InputGroup } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import {
  Update,
  findOne,
} from "../../../utils/apis/agentManagement/customer/index";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import Loader from "react-js-loader";
import { Eye, EyeSlash } from "react-bootstrap-icons";

function Edit(props) {
  const { UnauthorizedLogOut } = useContext(Context);
  const id = props.show;

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Password visibility states
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    setValue,
  } = useForm();

  const clientShare = watch("share");

  // Auto calculate "Your Share"
  useEffect(() => {
    if (clientShare) {
      setValue("your_share", 100 - Number(clientShare));
    }
  }, [clientShare, setValue]);

  const teen_patti_clientShare = watch("teen_patti_share");

  // Auto calculate "Your Share"
  useEffect(() => {
    if (teen_patti_clientShare) {
      setValue("teen_patti_your_share", 100 - Number(teen_patti_clientShare));
    }
  }, [teen_patti_clientShare, setValue]);

  // Fetch existing data
  const GetEditData = async () => {
    if (!id) return;
    setIsLoading(true);
    try {
      const response = await findOne(id);
      if (response?.data?.data) {
        reset(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    GetEditData();
  }, [id]);

  const onSubmit = async (data) => {
    setShimmerLoader(true);
    try {
      const sendData = new FormData();
      sendData.append("contact_no", data.contact_no);
      sendData.append("email", data.email);
      sendData.append("password", data.password);
      sendData.append("c_password", data.c_password);
      sendData.append("share", data.share);
      sendData.append("your_share", data.your_share);
      sendData.append("commission", data.commission);
      sendData.append("name", data.name);

      // sendData.append("teen_patti_share", data.teen_patti_share);
      // sendData.append("teen_patti_your_share", data.teen_patti_your_share);

      const result = await Update(id, sendData);

      const response = result.data;

      if (response?.code === HTTPS.ACCEPTED.code) {
        setShimmerLoader(false);
        setShowModal({
          code: response.code,
          message: response.data || "Updated successfully!",
        });

        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.onHide();
          reset();
        }, 2000);
      } else {
        setShimmerLoader(false);
        setError("email", {
          type: "manual",
          message: response?.errors || "Update failed",
        });
      }
    } catch (error) {
      setShimmerLoader(false);
      setError("email", {
        type: "manual",
        message: error?.response?.data?.errors || "An error occurred",
      });
      await UnauthorizedLogOut(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        className="Edit_User_Modal modal_holder"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal_Heading modalHeading="Edit Customer" />

        <Modal.Body>
          {isLoading ? (
            <div className="text-center py-5">
              <Loader type="bubble-top" bgColor="#000" color="#000" size={60} />
            </div>
          ) : (
            <div className="main-form-holder">
              <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Name</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="name"
                          placeholder="Enter Name"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          className={classNames({ "is-invalid": errors.email })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Contact No</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Enter Contact No"
                          {...register("contact_no", {
                            required: "Contact No is required",
                            minLength: {
                              value: 10,
                              message: "Must be 10 digits",
                            },
                            maxLength: {
                              value: 10,
                              message: "Must be 10 digits",
                            },
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: "Must be 10 digits",
                            },
                          })}
                          maxLength={10}
                          onKeyPress={(e) =>
                            !/[0-9]/.test(e.key) && e.preventDefault()
                          }
                        />
                      </InputGroup>
                      {errors.contact_no && (
                        <span className="text-danger">
                          {errors.contact_no.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Email</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email Address"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                              message: "Invalid Email Address",
                            },
                          })}
                          className={classNames({ "is-invalid": errors.email })}
                        />
                      </InputGroup>
                      {errors.email && (
                        <span className="text-danger">
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Login Password with Eye Icon */}
                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Login Password</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Login Password"
                          {...register("password", {
                            required: "Password is required",
                            pattern: {
                              value:
                                /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                              message:
                                "Password must be 8+ chars with uppercase, number & symbol",
                            },
                          })}
                        />
                        <InputGroup.Text
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? (
                            <EyeSlash size={18} />
                          ) : (
                            <Eye size={18} />
                          )}
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.password && (
                        <span className="text-danger">
                          {errors.password.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Confirm Password with Eye Icon */}
                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Confirm Password</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Confirm Password"
                          {...register("c_password", {
                            required: "Confirm Password is required",
                            validate: (value) =>
                              value === watch("password") ||
                              "Passwords do not match",
                          })}
                        />
                        <InputGroup.Text
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }>
                          {showConfirmPassword ? (
                            <EyeSlash size={18} />
                          ) : (
                            <Eye size={18} />
                          )}
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.c_password && (
                        <span className="text-danger">
                          {errors.c_password.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>
                  {/* 
                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Commission (%)</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          placeholder="Enter Commission"
                          {...register("commission", {
                            required: "Commission is required",
                            min: { value: 0, message: "Cannot be negative" },
                            max: { value: 100, message: "Cannot exceed 100%" },
                          })}
                        />
                      </InputGroup>
                      {errors.commission && (
                        <span className="text-danger">
                          {errors.commission.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col> */}

                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>His Share (%)</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          placeholder="Enter His Share"
                          {...register("share", {
                            required: "His Share is required",
                            min: { value: 0, message: "Cannot be negative" },
                            max: { value: 100, message: "Cannot exceed 100%" },
                          })}
                        />
                      </InputGroup>
                      {errors.share && (
                        <span className="text-danger">
                          {errors.share.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Your Share (%)</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="decimal"
                          disabled
                          placeholder="Your Share"
                          value={getValues("your_share") || ""}
                          {...register("your_share")}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  {/* <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Teen Patti His Share (%)</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          placeholder="Enter Teen Patti His Share"
                          {...register("teen_patti_share", {
                            required: "Teen Patti His Share is required",
                            min: { value: 0, message: "Cannot be negative" },
                            max: { value: 100, message: "Cannot exceed 100%" },
                          })}
                        />
                      </InputGroup>
                      {errors.teen_patti_share && (
                        <span className="text-danger">
                          {errors.teen_patti_share.message}
                        </span>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="main-form-section mt-3">
                      <Form.Label>Teen Patti Your Share (%)</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="decimal"
                          disabled
                          placeholder="Teen Patti Your Share"
                          value={getValues("teen_patti_your_share") || ""}
                          {...register("teen_patti_your_share")}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col> */}
                </Row>

                <div className="modal-footer-holder mt-4">
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <Button
                      variant="secondary"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    {shimmerLoader ? (
                      <Loader
                        type="bubble-top"
                        bgColor="#FFF"
                        color="#FFF"
                        size={50}
                      />
                    ) : (
                      <Button variant="primary" type="submit">
                        Update
                      </Button>
                    )}
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code !== 0}
      />
    </>
  );
}

export default Edit;
